// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"52409db1","48":"70260678","67":"e30577c9","71":"837bf2b2","160":"f8a6a64e","437":"9fd88cbc","634":"e91a9c5c","638":"d2b72e8b","682":"a5a0086c","881":"f785d58e"}[chunkId] + ".chunk.js";
};